<!-- 服务团队-预约导师弹窗  @click="maskCloseBtn"-->
<template>
  <div class='modal-mask'
       v-if='isShow'>
    <div class='modal-wrap'>
      <div class='modal-container'
           :style='{width: defaultWidth}'
           @click="closeContainerBtn">
        <h3 class='big-title'>{{computedMnetor}}</h3>
        <div class='forms-kind'>
          <h4 class='small-title'>选择视频工具</h4>
          <Row class='item-list'
               :gutter='10'>
            <Col span='24'
                 v-for='item in videoList'
                 :key='item.id'>
            <div class='form-item'
                 @click="checkVideoTools(item)">
              <a href='javascript:void(0);'
                 :class="[item.checked ? 'active' : '']">{{item.name}}</a>
              <img :src='checkedPic'
                   v-if='item.checked' />
            </div>
            </Col>
          </Row>
          <p class='error'>{{videoError}}</p>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>选择模块</h4>
          <Row class='item-list'>
            <Col span='12'
                 v-for='item in moduleList'
                 :key='item.id'>
            <div class='form-item'
                 @click="checkModule(item)">
              <a href='javascript:void(0);'
                 :class="[item.checked ? 'active' : '']"><span :class="[item.checkable ? '' : 'uncheckable']">{{item.name}}</span></a>
              <img :src='checkedPic'
                   v-if='item.checked' />
            </div>
            </Col>
          </Row>
          <p class='error'>{{moduleError}}</p>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>预计讨论时间</h4>
          <p class="remaining-time" v-if="remainingTime">你的剩余时长为{{remainingTime}}  mins，剩余时长小于15 mins则不能预约导师，请合理安排预约时长。</p>
          <Row class='item-list'>
            <Col span='6'
                 v-for='item in discussionList'
                 :key='item.id'>
            <div class='form-item'
                 @click="checkDiscussion(item)">
              <a href='javascript:void(0);'
                 :class="[item.checked ? 'active' : '']"><span :class="[item.checkable ? '' : 'uncheckable']">{{item.name}}</span></a>
              <img :src='checkedPic'
                   v-if='item.checked' />
            </div>
            </Col>
          </Row>
          <p class='error'>{{discussionError}}</p>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>讨论主题</h4>
          <Row class='item-list'>
            <Col span='24'>
            <div class='form-item'>
              <Input v-model='formValidate.title'
                     clearable />
            </div>
            </Col>
          </Row>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>您所在的时区</h4>
          <Row class='item-list'>
            <Col span='24'>
            <div class='form-item'>
              <Select v-model='formValidate.menteeZone'
                      @on-change='changTimeZone'
                      clearable>
                <Option v-for='item in zoneEnMap'
                        :value='item.value'
                        :key='item.value'>{{item.title}}</Option>
              </Select>
            </div>
            </Col>
          </Row>
          <p class='error'>{{zoneError}}</p>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>你期望的辅导时间</h4>
          <p class='warning'>请选择你所在时区的时间，为了更好的为你服务，建议你预约至少两天以后的某个时间</p>
          <Row class='item-list'>
            <Col span='24'>
            <div class='form-item'>
              <p class='time-title'>第一选择</p>
              <div>
                <DatePicker type="date"
                            v-model="dateOne"
                            :editable='false'
                            :options="optionsTime"
                            placeholder="Select date"
                            style="display:inline-block"
                            @on-change='dateCheckOneDate'></DatePicker>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateOneStartTime"
                            :editable='false'
                            :disabled='!dateOne'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckOneStartTime'></TimePicker>
                <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateOneEndTime"
                            :editable='false'
                            :disabled='!dateOneStartTime'
                            :disabled-hours='dateOneEndTimeOption'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckOneEndTime'></TimePicker>
              </div>
              <p class='error'>{{dateOneError}}</p>
            </div>
            </Col>
            <Col span='24'>
            <div class='form-item'>
              <p class='time-title'>第二选择</p>
              <div>
                <DatePicker type="date"
                            v-model="dateTwo"
                            :editable='false'
                            :options="optionsTime"
                            placeholder="Select date"
                            style="display:inline-block"
                            @on-change='dateCheckTwoDate'></DatePicker>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateTwoStartTime"
                            :editable='false'
                            :disabled='!dateTwo'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckTwoStartTime'></TimePicker>
                <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateTwoEndTime"
                            :editable='false'
                            :disabled='!dateTwoStartTime'
                            :disabled-hours='dateTwoEndTimeOption'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckTwoEndTime'></TimePicker>
              </div>
              <p class='error'>{{dateTwoError}}</p>
            </div>
            </Col>
            <Col span='24'>
            <div class='form-item'>
              <p class='time-title'>第三选择</p>
              <div>
                <DatePicker type="date"
                            v-model="dateThree"
                            :editable='false'
                            :options="optionsTime"
                            placeholder="Select date"
                            style="display:inline-block"
                            @on-change='dateCheckThreeDate'></DatePicker>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateThreeStartTime"
                            :editable='false'
                            :disabled='!dateThree'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckThreeStartTime'></TimePicker>
                <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                <TimePicker type="time"
                            v-model="dateThreeEndTime"
                            :editable='false'
                            :disabled='!dateThreeStartTime'
                            :disabled-hours='dateThreeEndTimeOption'
                            placeholder="Select time"
                            format="HH:mm"
                            style="display:inline-block"
                            @on-change='dateCheckThreeEndTime'></TimePicker>
              </div>
              <p class='error'>{{dateThreeError}}</p>
            </div>
            </Col>
          </Row>
        </div>
        <div class='forms-kind'>
          <h4 class='small-title'>其他您想告知导师的信息（请填写英文）</h4>
          <Row class='item-list'>
            <Col span='24'>
            <div class='form-item'>
              <Input type='textarea'
                     :rows='5'
                     v-model='formValidate.otherMsg' />
            </div>
            </Col>
          </Row>
        </div>
        <div class='oper'>
          <Button href='javascript:void(0)'
                  @click="appointCancel"
                  class='cancel'>取消</Button>
          <Button href='javascript:void(0)'
                  @click="appointOk"
                  :loading='hasService'
                  class='ok'>发起预约</Button>
        </div>
        <div class='modal-close'
             @click="maskCloseBtn">
          <img :src='modalClose' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceService from '@/api/undergraduate/service'
import checkedPic from '@/assets/undergraduate/images/checked.png'
import modalClose from '@/assets/undergraduate/images/modal_close.png'
import { mentorRoleEnMap, mentorRoleCnMap, zoneEnMap, videoMap } from '../constantsEnum'
export default {
  name: '',
  props: {
    // 当前导师
    currMentor: {
      type: Object,
      default: () => { }
    },
    // 当前导师可选套餐模块
    appointModule: {
      type: Array,
      default: () => []
    },
    hasService: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    defaultWidth: {
      type: String,
      default: '500px'
    }
  },
  components: {},
  data () {
    return {
      optionsTime: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      // 选中图标
      checkedPic,
      // 关闭图标
      modalClose,
      // 视频工具
      videoList: [],
      // 模块
      moduleList: [],
      // 预计讨论时间
      discussionList: [
        {
          id: 15,
          name: '15 mins',
          checkable: true,
          checked: false
        },
        {
          id: 30,
          name: '30 mins',
          checkable: true,
          checked: false
        },
        {
          id: 45,
          name: '45 mins',
          checkable: true,
          checked: false
        },
        {
          id: 60,
          name: '60 mins',
          checkable: true,
          checked: false
        },
        {
          id: '75',
          name: '75 mins',
          checkable: true,
          checked: false
        },
        {
          id: 90,
          name: '90 mins',
          checkable: true,
          checked: false
        }
      ],
      remainingTime: 0,
      // 时区映射
      zoneEnMap,
      dateOne: '',
      dateOneStartTime: '',
      dateOneEndTime: '',
      dateOneEndTimeOption: [],
      dateTwo: '',
      dateTwoStartTime: '',
      dateTwoEndTime: '',
      dateTwoEndTimeOption: [],
      dateThree: '',
      dateThreeStartTime: '',
      dateThreeEndTime: '',
      dateThreeEndTimeOption: [],
      formValidate: {
        videoType: 'ZOOM',
        module: '',
        predictTime: '',
        title: '',
        menteeZone: '',
        dateOne: ['', ''],
        dateTwo: ['', ''],
        dateThree: ['', ''],
        other: ''
      },
      videoError: '',
      moduleError: '',
      discussionError: '',
      zoneError: '',
      dateOneError: '',
      dateTwoError: '',
      dateThreeError: ''
    }
  },
  computed: {
    computedMnetor () {
      if (this.currMentor && this.currMentor.mentorType && this.currMentor.mentorName) {
        return `${new Map(mentorRoleEnMap).get(this.currMentor.mentorType)}-${new Map(mentorRoleCnMap).get(this.currMentor.mentorType)}-${this.currMentor.mentorName}`
      }
      return ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.videoList = [{ ...videoMap[0], checked: true }]
      this.moduleList = this.appointModule
    })
  },
  methods: {
    // 遮罩层点击关闭
    maskCloseBtn () {
      this.resetState()
      this.$emit('closeModal')
    },
    // 阻止冒泡
    closeContainerBtn (e) {
      e.stopPropagation()
      return false
    },
    // 选择视频工具
    checkVideoTools (item) {
      this.formValidate.videoType = item.id
      this.videoError = ''
      this.videoList.map(data => {
        if (data.id === item.id) {
          data.checked = true
        } else {
          data.checked = false
        }
        return data
      })
    },
    // 选择模块
    checkModule (item) {
      if (!item.checkable) {
        return
      }
      serviceService.serviceTeamModuleResidueTime({ jointId: this.currMentor.id, module: item.id }).then(res => {
        this.remainingTime = res.data.model
        this.formValidate.predictTime = ''
        this.discussionError = ''
        this.discussionList.map(data => {
          data.checked = false
          if (data.id <= res.data.model) {
            data.checkable = true
          } else {
            data.checkable = false
          }
          return data
        })
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
      this.formValidate.module = item.id
      this.moduleError = ''
      this.moduleList.map(data => {
        if (data.id === item.id) {
          data.checked = true
        } else {
          data.checked = false
        }
        return data
      })
    },
    // 预计讨论时间
    checkDiscussion (item) {
      if (!item.checkable) {
        return
      }
      this.formValidate.predictTime = item.id
      this.discussionError = ''
      this.discussionList.map(data => {
        if (data.id === item.id) {
          data.checked = true
        } else {
          data.checked = false
        }
        return data
      })
    },
    // 选择时区
    changTimeZone (val) {
      this.formValidate.menteeZone = val
      if (val) {
        this.zoneError = ''
      } else {
        this.zoneError = '请选择你所在的时区'
      }
    },
    // 第一选择日期
    dateCheckOneDate (val) {
      this.dateOne = val
      this.dateOneStartTime = ''
      this.formValidate.dateOne = ['', '']
      if (this.dateOne !== '') {
        this.dateOneError = ''
      } else {
        this.dateOneError = '请选择日期或时间'
      }
    },
    dateCheckOneStartTime (val) {
      this.dateOneStartTime = val
      this.dateOneEndTime = ''
      this.formValidate.dateOne[1] = ''
      if (this.dateOneStartTime !== '') {
        this.formValidate.dateOne[0] = `${this.dateOne} ${val}`
        this.dateOneError = ''
      } else {
        this.formValidate.dateOne[0] = ''
        this.dateOneError = '请选择日期或时间'
      }
    },
    dateCheckOneEndTime (val) {
      this.dateOneEndTime = val
      if (this.dateOneEndTime !== '') {
        this.formValidate.dateOne[1] = `${this.dateOne} ${val}`
        this.dateOneError = ''
      } else {
        this.formValidate.dateOne[1] = ''
        this.dateOneError = '请选择日期或时间'
      }
    },
    // 第二选择日期
    dateCheckTwoDate (val) {
      this.dateTwo = val
      this.dateTwoStartTime = ''
      this.formValidate.dateTwo = ['', '']
      if (this.dateTwo !== '') {
        this.dateTwoError = ''
      } else {
        this.dateTwoError = '请选择日期或时间'
      }
    },
    dateCheckTwoStartTime (val) {
      this.dateTwoStartTime = val
      this.dateTwoEndTime = ''
      this.formValidate.dateTwo[1] = ''
      if (this.dateTwoStartTime !== '') {
        this.formValidate.dateTwo[0] = `${this.dateTwo} ${val}`
        this.dateTwoError = ''
      } else {
        this.formValidate.dateTwo[0] = ''
        this.dateTwoError = '请选择日期或时间'
      }
    },
    dateCheckTwoEndTime (val) {
      this.dateTwoEndTime = val
      if (this.dateTwoEndTime !== '') {
        this.formValidate.dateTwo[1] = `${this.dateTwo} ${val}`
        this.dateTwoError = ''
      } else {
        this.formValidate.dateTwo[1] = ''
        this.dateTwoError = '请选择日期或时间'
      }
    },
    // 第三选择日期
    dateCheckThreeDate (val) {
      this.dateThree = val
      this.dateThreeStartTime = ''
      this.formValidate.dateThree = ['', '']
      if (this.dateThree !== '') {
        this.dateThreeError = ''
      } else {
        this.dateThreeError = '请选择日期或时间'
      }
    },
    dateCheckThreeStartTime (val) {
      this.dateThreeStartTime = val
      this.dateThreeEndTime = ''
      this.formValidate.dateThree[1] = ''
      if (this.dateThreeStartTime !== '') {
        this.formValidate.dateThree[0] = `${this.dateThree} ${val}`
        this.dateThreeError = ''
      } else {
        this.formValidate.dateThree[0] = ''
        this.dateThreeError = '请选择日期或时间'
      }
    },
    dateCheckThreeEndTime (val) {
      this.dateThreeEndTime = val
      if (this.dateThreeEndTime !== '') {
        this.formValidate.dateThree[1] = `${this.dateThree} ${val}`
        this.dateThreeError = ''
      } else {
        this.formValidate.dateThree[1] = ''
        this.dateThreeError = '请选择日期或时间'
      }
    },
    // 确认弹窗的确认操作
    appointOk () {
      if (this.checkValid()) {
        let data = this.formValidate
        data.content = [
          {
            maxTime: this.formValidate.dateOne[1],
            maxTimeStr: this.formValidate.dateOne[1],
            minTime: this.formValidate.dateOne[0],
            minTimeStr: this.formValidate.dateOne[0]
          },
          {
            maxTime: this.formValidate.dateTwo[1],
            maxTimeStr: this.formValidate.dateTwo[1],
            minTime: this.formValidate.dateTwo[0],
            minTimeStr: this.formValidate.dateTwo[0]
          },
          {
            maxTime: this.formValidate.dateThree[1],
            maxTimeStr: this.formValidate.dateThree[1],
            minTime: this.formValidate.dateThree[0],
            minTimeStr: this.formValidate.dateThree[0]
          }
        ]
        this.$emit('appointModalOk', data)
      }
    },
    // 校验
    checkValid () {
      let isValid = true
      if (this.formValidate.videoType === '') {
        this.videoError = '请选择视频工具'
        isValid = false
      }
      if (this.formValidate.module === '') {
        this.moduleError = '请选择模块'
        isValid = false
      }
      if (this.formValidate.predictTime === '') {
        this.discussionError = '请选择预计讨论时间'
        isValid = false
      }
      if (this.formValidate.menteeZone === '') {
        this.zoneError = '请选择你所在的时区'
        isValid = false
      }
      if (this.formValidate.dateOne[0] === '' || this.formValidate.dateOne[1] === '') {
        this.dateOneError = '请选择日期或时间'
        isValid = false
      }
      if (this.formValidate.dateTwo[0] === '' || this.formValidate.dateTwo[1] === '') {
        this.dateTwoError = '请选择日期或时间'
        isValid = false
      }
      if (this.formValidate.dateThree[0] === '' || this.formValidate.dateThree[1] === '') {
        this.dateThreeError = '请选择日期或时间'
        isValid = false
      }
      return isValid
    },
    // 确认弹窗的取消操作
    appointCancel () {
      this.maskCloseBtn()
    },
    // 重置操作
    resetState () {
      this.videoList.map(data => {
        data.checked = false
        return data
      })
      this.moduleList.map(data => {
        data.checked = false
        return data
      })
      this.discussionList.map(data => {
        data.checked = false
        return data
      })
      this.formValidate = {
        videoType: '',
        module: '',
        predictTime: '',
        title: '',
        menteeZone: '',
        dateOne: ['', ''],
        dateTwo: ['', ''],
        dateThree: ['', ''],
        other: ''
      }
      this.videoError = ''
      this.moduleError = ''
      this.discussionError = ''
      this.zoneError = ''
      this.dateOneError = ''
      this.dateTwoError = ''
      this.dateThreeError = ''
      this.dateOne = ''
      this.dateOneStartTime = ''
      this.dateOneEndTime = ''
      this.dateOneEndTimeOption = []
      this.dateTwo = ''
      this.dateTwoStartTime = ''
      this.dateTwoEndTime = ''
      this.dateTwoEndTimeOption = []
      this.dateThree = ''
      this.dateThreeStartTime = ''
      this.dateThreeEndTime = ''
      this.dateThreeEndTimeOption = []
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    position: absolute;
    top: 100px;
    bottom: 100px;
    overflow-y: scroll;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 #e6eaf1;
    .modal-container {
      background: #fff;
      padding: 30px 50px;
      position: relative;
      .big-title {
        font-size: 20px;
        color: #667483;
        letter-spacing: 0;
        text-align: center;
        font-weight: normal;
      }
      .forms-kind {
        padding-top: 40px;
        .small-title {
          padding-bottom: 10px;
          font-size: 16px;
          color: #667483;
          letter-spacing: 0;
          text-align: center;
          font-weight: normal;
        }
        .warning {
          font-size: 14px;
          line-height: 28px;
          color: #ff6020;
          letter-spacing: 0;
        }
        .item-list {
          .form-item {
            position: relative;
            .time-title {
              padding: 10px 0;
            }
            a {
              display: block;
              border: 1px solid #b1bcc8;
              border-radius: 8px;
              font-size: 14px;
              height: 38px;
              line-height: 38px;
              margin: 10px;
              text-align: center;
              color: #667483;
              &.active {
                background: #e7f0fe;
                border: 2px solid #4aa6ff;
                border-radius: 8px;
              }
              .uncheckable {
                display: block;
                height: 36px;
                border-radius: 8px;
                background: #eee;
              }
            }
            img {
              width: 14px;
              height: 14px;
              position: absolute;
              right: 10px;
              top: 0;
            }
            .time-title {
              font-size: 14px;
              color: #667483;
              letter-spacing: 0;
              line-height: 24px;
            }
          }
        }
      }
      .oper {
        text-align: center;
        button {
          display: inline-block;
          font-size: 14px;
          margin: 20px;
          width: 116px;
          height: 32px;
          border-radius: 8px;
          text-align: center;
        }
        .cancel {
          border: 1px solid #b1bcc8;
          color: #b1bcc8;
        }
        .ok {
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          color: #fff;
        }
      }
      .remaining-time {
        font-size: 14px;
        color: #ff612f;
        padding-left: 10px;
      }
      .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 36px;
        height: 36px;
        padding: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .error {
    padding-left: 10px;
    line-height: 20px;
    color: #f00;
  }
}
</style>
